$(document).ready(function () {
	
	/*_____ Slick Static Features Slider _____*/
	$("#slick-seen").slick({
		dots: false,
		arrows: false,
		infinite: true,
		autoplay: true,
		autoplaySpeed: 0,
		speed: 5000,
		pauseOnHover: true,
		cssEase: 'linear',
		slidesToShow: 5,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 576,
				settings: {
					slidesToShow: 2,
				},
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 3,
				},
			}
		],
	});

	/*_____ Slick Moment Slider _____*/
	$("#slick-moments").slick({
		dots: false,
		arrows: false,
		infinite: true,
		autoplay: true,
		autoplaySpeed: 0,
		speed: 5000,
		pauseOnHover: true,
		cssEase: 'linear',
		slidesToShow: 6,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 2,
				},
			},
			{
				breakpoint: 580,
				settings: {
					slidesToShow: 3,
				},
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 4,
				},
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 5,
				},
			},
		],
	})

  $('#collection-slider').slick({
		dots: false,
		arrows: true,
		infinite: false,
		autoplay: false,
		speed: 500,
		cssEase: 'linear',	
		prevArrow: '<button class="slide-arrow prev-arrow"><i class="fas fa-long-arrow-left"></i></button>',
        nextArrow: '<button class="slide-arrow next-arrow"><i class="fas fa-long-arrow-right"></i></button>',
		slidesToShow: 4,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 1199,
				settings: {
					slidesToShow: 3,
				}
			},
		  {
			breakpoint: 991,
			settings: {
			  slidesToShow: 2,
			}
		  },
		  {
			breakpoint: 767,
			settings: {
			  slidesToShow: 1,
			}
		  }]
	  });




  $("#slick-partner").slick({
		dots: false,
		arrows: false,
		infinite: true,
		centerMode: true,
		centerPadding: 0,
		speed: 1000,
		focusOnSelect: true,
		slidesToShow: 5,
		slidesToScroll: 1,
		asNavFor: "#slick-partner-content",
		responsive: [
			{
				breakpoint: 769,
				settings: {
					slidesToShow: 3,
				},
			},
			{
				breakpoint: 580,
				settings: {
					slidesToShow: 3,
				},
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 2,
				},
			},
		],
	})
	$("#slick-partner-content").slick({
		dots: false,
		arrows: false,
		infinite: true,
		draggable: false,
		speed: 1000,
		slidesToShow: 1,
		slidesToScroll: 1,
		asNavFor: "#slick-partner",
	});

  $("#slick-review").slick({
		dots: false,
		arrows: false,
		vertical: true,
		verticalSwiping: true,
		slidesToShow: 2,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 0,
		speed: 8000,
		pauseOnHover: true,
		cssEase: 'linear',
        swipeToSlide:true,
        responsive: [
			{
				breakpoint: 991,
				settings: {
					slidesToShow: 1,
				},
			},
		],
	});

  $(".slick-blocks").slick({
		dots: false,
		arrows: true,
		infinite: false,
		speed: 1000,
		slidesToShow: 4,
		slidesToScroll: 1,
        touchThreshold:100,
        swipeToSlide: true,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
				},
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 3,
				},
			},
		],
	});

  $("#slick-insight").slick({
		dots: false,
		arrows: false,
		infinite: true,
		speed: 1000,
		slidesToShow: 4,
		slidesToScroll: 1,
        touchThreshold:100,
        swipeToSlide: true,
		responsive: [
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 2,
				},
			},
			{
				breakpoint: 769,
				settings: {
					slidesToShow: 3,
				},
			},
		],
	});

  // To check If it is in Viewport
  var $window = $(window)
  function check_if_in_view() {
  	$(".num > span").each(function () {
  		if ($(this).hasClass("start")) {
  			var elementTop = $(this).offset().top
  			var elementBottom = elementTop + $(this).outerHeight()
  
  			var viewportTop = $(window).scrollTop()
  			var viewportBottom = viewportTop + $(window).height()
  
  			if (elementBottom > viewportTop && elementTop < viewportBottom) {
  				$(this).removeClass("start")
  				$(".num > span").text()
  				var myNumbers = $(this).text()
  				if (myNumbers == Math.floor(myNumbers)) {
  					$(this).animate(
  						{
  							Counter: $(this).text(),
  						},
  						{
  							duration: 2800,
  							easing: "swing",
  							step: function (now) {
  								$(this).text(Math.ceil(now) + "")
  							},
  						}
  					)
  				}
  			}
  		}
  	})
  }
  
  $window.on("scroll", check_if_in_view)
  $window.on("load", check_if_in_view)
})
